import { Component, DestroyRef, HostListener, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { Subject, throttleTime } from 'rxjs';

import { MigrationTabType } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsMigrationTab } from '../../models/my-bets-tab';
import { MyBetsMigrationTabsService } from '../../services/my-bets-migration-tabs.service';

@Component({
    selector: 'ms-my-bets-migration-tabs',
    templateUrl: 'my-bets-migration-tabs.html',
})
export class MyBetsMigrationTabsComponent implements OnInit {
    @Input() isSettled: boolean;
    tabNames: { [key: string]: string };
    migrationInfo = false;
    wasMigrationInfoShown = false;
    private click$ = new Subject<MyBetsMigrationTab>();
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        sitecoreMyBets: SitecoreMyBetsConfig,
        private myBetsMigrationTabService: MyBetsMigrationTabsService,
    ) {
        this.tabNames = {
            [MigrationTabType.After]: sitecoreMyBets.myBets.AfterMigrationText,
            [MigrationTabType.Before]: sitecoreMyBets.myBets.BeforeMigrationText,
        };
    }

    ngOnInit(): void {
        this.click$.pipe(throttleTime(250), takeUntilDestroyed(this.destroyRef)).subscribe((tab: MyBetsMigrationTab) => {
            this.myBetsMigrationTabService.selectedTab = tab;
        });
    }

    get tabs(): MyBetsMigrationTab[] {
        return this.myBetsMigrationTabService.migrationTabs;
    }

    onSelectTab(tab: MyBetsMigrationTab): void {
        this.click$.next(tab);
    }

    @HostListener('document:click')
    clickout(): void {
        if (!this.wasMigrationInfoShown) {
            this.closeMigrationInfo();
        }
        this.wasMigrationInfoShown = false;
    }

    showMigrationInfo(): void {
        this.migrationInfo = true;
        this.wasMigrationInfoShown = true;
    }

    closeMigrationInfo(): void {
        this.migrationInfo = false;
    }
}
